import getAuth0 from '.'
import { newRelicTimeFunction } from '../newrelic'

export default async function handleCallback(): Promise<void> {
  const auth0 = getAuth0()
  try {
    await newRelicTimeFunction('handleRedirectCallback', () => auth0.handleRedirectCallback())
  } catch (error: any) {
    if (error.message !== 'Invalid state') throw error
    try {
      await auth0.getTokenSilently()
    } catch (_error) {
      throw error
    }
  }
}
